
Greenmile.EventNotifications = Greenmile.EventNotifications || {};
Greenmile.EventNotifications.Coordinate = Greenmile.EventNotifications.Coordinate || {};
Greenmile.EventNotifications.Coordinate.TableView = Greenmile.EventNotifications.Coordinate.TableView || {};

Greenmile.EventNotifications.Coordinate.TableView = (function () {

    function CoordinateTableView (eventLog) {

        var getDateLine = function (coord) {
            return [
                new Monet.UI.TableViewCell('TEXT', Monet.I18n.getResourcesByKey('route.date')),
                new Monet.UI.TableViewCell('DATE_TIME', coord.date)
            ];
        };

        var getLatLongLine = function (resourceId, value) {
            return [
                new Monet.UI.TableViewCell('TEXT', Monet.I18n.getResourcesByKey(resourceId)),
                new Monet.UI.TableViewCell('LAT_LONG', value)
            ];
        };

        var formatSpeed = function (speed) {

            var formatter = new Monet.Format.DISTANCE(speed);
            var unitSystem = Monet.Session.User.unitSystem;
            var unitSystemStr = "Greenmile.UnitMetrics.kilometersPerHour";

            if (unitSystem === "NON_METRIC") {

                unitSystemStr = "Greenmile.UnitMetrics.milesPerHour";
                formatter.convertKmToMiles();

            }

            return formatter.format().getValue() + ' ' + Monet.I18n.getResourcesByKey(unitSystemStr);

        };

        var getSpeedLine = function (coord) {
            var speed = formatSpeed(coord.speedKmh);

            return [
                new Monet.UI.TableViewCell('TEXT', Monet.I18n.getResourcesByKey('RouteDetail.PopUp.speed')),
                new Monet.UI.TableViewCell('TEXT', speed)
            ];
        };

        var getEngineOnLine = function (coord) {
            var engineON = '.';

            if (coord.engineOn) {
                engineON = (coord.engineOn ? 'EventNotification.engine.on' : 'EventNotification.engine.off');
            }

            return [
                new Monet.UI.TableViewCell('TEXT', Monet.I18n.getResourcesByKey('EventNotification.engine')),
                new Monet.UI.TableViewCell('TEXT', Monet.I18n.getResourcesByKey(engineON))
            ];
        };

        this.getCoordinateTabContent = function () {

            var coordinate = eventLog.startCoord;
            var lines = { data: [] };
            var content = null;

            if (coordinate) {

                lines.data.push(getDateLine(coordinate));
                lines.data.push(getSpeedLine(coordinate));
                lines.data.push(getEngineOnLine(coordinate));
                lines.data.push(getLatLongLine('eventLog.latitude', coordinate.position.latitude));
                lines.data.push(getLatLongLine('eventLog.longitude', coordinate.position.longitude));

            } else if (eventLog.latitude && eventLog.longitude) {

                lines.data.push(getLatLongLine('eventLog.latitude', eventLog.latitude));
                lines.data.push(getLatLongLine('eventLog.longitude', eventLog.longitude));

            }

            if (lines.data.length) {
                var grid = new Monet.UI.TableView();
                grid.setLines(lines);
                content = grid.render();
            } else {

                var noCoordMsg = document.createElement('div');
                noCoordMsg.className = 'EventNotificationTabHeader';
                noCoordMsg.innerHTML = Monet.I18n.getResourcesByKey('EventNotification.noCoordsFound');
                content = noCoordMsg;
            }

            return content;

        };

    }

    return CoordinateTableView;

})();

